export default {
  TODO_ITEM: {
    INCREMENT: "+",
    DECREMENT: "-",
    MOVE_UP: "command+up",
    MOVE_DOWN: "command+down",
    EDIT: "enter"
  },
  EDIT_VIEW: {
    FOCUS_INPUT: "command+i",
    PREVIOUS_LIST: "command+shift+up",
    NEXT_LIST: "command+shift+down",
    SHOPPING_MODE: "command+u"
  },
  SHOPPING_VIEW: {
    EDIT_MODE: "command+i",
    PREVIOUS_LIST: "command+shift+up",
    NEXT_LIST: "command+shift+down"
  }
};



// WEBPACK FOOTER //
// ./src/keymap.js